/** Keep in sync with sicily-backend/lib/orderPricing.js */
export const SMALL_ORDER_SURCHARGE_THRESHOLD_EUR = 300;
export const SMALL_ORDER_SURCHARGE_EUR = 25;

const NEW_SHIPPING_RATES_FROM = new Date('2025-09-16');

export function cartSubtotal(cart) {
    if (!Array.isArray(cart)) return 0;
    return cart.reduce(
        (sum, item) => sum + Number(item.price) * Number(item.amount),
        0
    );
}

export function calculateSurchargeFromCart(cart, pickup = false) {
    if (pickup) return 0;
    const sum = cartSubtotal(cart);
    if (sum < SMALL_ORDER_SURCHARGE_THRESHOLD_EUR) return SMALL_ORDER_SURCHARGE_EUR;
    return 0;
}

/** @param {boolean} useNewRates — matches backend `calculateShippingNew` vs `calculateShipping`. */
export function calculateShippingFromCart(cart, useNewRates) {
    const sum = cartSubtotal(cart);
    if (useNewRates) {
        if (sum > 500) return sum * 0.28;
        return sum * 0.3;
    }
    if (sum > 500) return sum * 0.23;
    return sum * 0.25;
}

export function useNewShippingRatesForOrder(order) {
    const orderDate = order?.date ? new Date(order.date) : new Date();
    return orderDate > NEW_SHIPPING_RATES_FROM;
}

export function computeOrderAmountsFromCart(
    cart,
    { pickup = false, useNewShippingRates = true } = {}
) {
    const total = cartSubtotal(cart);
    const surcharge = calculateSurchargeFromCart(cart, pickup);
    const shipping = calculateShippingFromCart(cart, useNewShippingRates);
    return { total, surcharge, shipping };
}

/** Recompute product total, surcharge, and shipping when the cart changes during order edit. */
export function applyCartPricingToOrder(order, cart) {
    const useNewShippingRates = useNewShippingRatesForOrder(order);
    const { total, surcharge, shipping } = computeOrderAmountsFromCart(cart, {
        pickup: Boolean(order?.pickup),
        useNewShippingRates,
    });
    return { ...order, cart, total, surcharge, shipping };
}
